import { Card, PageHead } from '../components/ui';
import { Icon } from '../components/icons';

/**
 * Certificats AS2 — ÉCRAN PAS ENCORE CONSTRUIT.
 *
 * ⚠️ POURQUOI VIDE PLUTÔT QUE PEUPLÉ. Cet écran affichait quatre certificats en dur — empreintes SHA1 et
 * échéances comprises, dont une « expire dans 6 j » en rouge. Une alerte d'exploitation fabriquée fait
 * AGIR : on court renouveler un certificat qui n'existe pas, et on cesse de surveiller les vrais ailleurs.
 * C'est l'interdit du §23.0 (donnée inventée rendue comme réelle), doublé de trois boutons qui répondaient
 * « (démo) » (option offerte non implémentée).
 *
 * CE QUI LE DÉBLOQUERA : le tunnel AS2 dédié (`transports/factory.ts` refuse aujourd'hui le protocole
 * `as2`) et les routes serveur qui exposeront les certificats — il n'en existe aucune. Tant que les deux
 * manquent, il n'y a rien de vrai à afficher, et l'écran le dit au lieu de le simuler.
 */
export function Certificats() {
  return (
    <>
      <PageHead title="Certificats AS2" />

      <Card style={{ border: '1px dashed var(--ink-300)', boxShadow: 'none', maxWidth: 720, padding: '26px 24px', display: 'flex', gap: 16, alignItems: 'flex-start' }}>
        <span style={{ color: 'var(--ink-400)', flexShrink: 0, marginTop: 2 }}><Icon name="lock" size={22} /></span>
        <div style={{ minWidth: 0 }}>
          <p style={{ margin: '0 0 10px', fontSize: 'var(--t-lead)', fontWeight: 600, color: 'var(--ink-900)' }}>
            Cet écran n'est pas encore construit.
          </p>
          <p style={{ margin: '0 0 12px', fontSize: 'var(--t-body)', color: 'var(--ink-500)', lineHeight: 1.6 }}>
            Il portera la gestion des certificats AS2 : celui d'Orgazone et ceux des partenaires, pour la
            signature et le chiffrement des échanges, avec la surveillance de leurs échéances.
          </p>
          <p style={{ margin: '0 0 12px', fontSize: 'var(--t-body)', color: 'var(--ink-500)', lineHeight: 1.6 }}>
            Deux choses lui manquent pour exister : le transport AS2, dont le driver n'est pas implémenté,
            et des routes serveur — aucune n'expose de certificat aujourd'hui. Il n'y a donc rien de réel à
            afficher, et la console préfère le dire plutôt que d'inventer des empreintes et des échéances.
          </p>
          <p style={{ margin: '0 0 12px', fontSize: 'var(--t-body)', color: 'var(--ink-500)', lineHeight: 1.6 }}>
            En attendant, les certificats AS2 se gèrent hors de cette console, directement avec chaque
            partenaire.
          </p>
          <p style={{ margin: 0, fontSize: 'var(--t-note)', color: 'var(--ink-400)', lineHeight: 1.6 }}>
            Une règle tiendra quand l'écran existera : une clé privée ne s'importe jamais depuis un
            navigateur — seules les chaînes publiques transiteront ici.
          </p>
        </div>
      </Card>
    </>
  );
}
